<template>
  <div
    class="td-content"
    v-tooltip="tooltip"
  >
    {{ isEmptyValue ? defaultEmptyValue : value }}
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "wt-single-row-value",
  props: {
    data: {
      type: Object,
    },
    header: {
      type: Object,
    },
  },
  data() {
    return {
      defaultEmptyValue: "-",
    };
  },
  computed: {
    value() {
      const { field, filter } = this.header;

      if (filter) {
        return Vue.filter(filter)(this.data[field]);
      } else {
        return this.data[field];
      }
    },
    isEmptyValue() {
      return this.value == "" || this.value == null;
    },
    tooltip() {
      const { tooltip } = this.header;

      if (typeof tooltip === "function") {
        return {
          content: tooltip(this.data),
          container: ".td-content",
        };
      // eslint-disable-next-line no-extra-boolean-cast
      } else if (!!tooltip) {
        return {
          content: tooltip,
          container: ".td-content",
        };
      }

      return null;
    },
  },
};
</script>